import { HashRouter } from 'react-router-dom';
import Footer from '../common/footer'
import Pace from '../pages/pace';
import Header from '../common/header'
import Router from './Router';
import BtnWhatsapp from '../common/btnWhatsapp';
import FooterCalculator from '../common/footerCalculador';
import { isAllowed } from '../shared/utils/permissions';

function Aplicacion() {
  return (
    <HashRouter>
      <Pace color="#fff" />
      <Header />      
      <Router />
      { isAllowed(19) ? <BtnWhatsapp/> : null }
      <FooterCalculator/>
      <Footer />
    </HashRouter>
  );
}

export default Aplicacion;